import { Injectable } from '@angular/core';
import { PartnerService } from '@principle-theorem/ng-principle-shared';
import { IPartner } from '@principle-theorem/principle-core/interfaces';
import {
  filterUndefined,
  type ResolverResult,
  type WithRef,
} from '@principle-theorem/shared';
import { map } from 'rxjs/operators';

@Injectable()
export class PartnerResolver {
  constructor(private _partner: PartnerService) {}

  resolve(): ResolverResult<WithRef<IPartner>> {
    return this._partner.partner$.pipe(
      filterUndefined(),
      map((partner) => {
        if (!partner) {
          throw new Error(`Can't find partner`);
        }

        return partner;
      })
    );
  }
}
